import reduce from "lodash/reduce";
import * as dateTimeFormats from "../../constants/dateTimeFormats";

const common = {
  ...reduce(
    dateTimeFormats,
    (acc, format) => {
      acc[format] = `{{date, ${format}}}`;
      return acc;
    },
    {}
  ),
  CURRENCY: "{{data, CURRENCY}}",
  RELATIVE_DATE_TIME: "{{date, RELATIVE_DATE_TIME}}",
  KEYBOARD_DATE: "dd/MM/yyyy",
  "Email address": "Email address",
  Password: "Password",
  "Sign Up": "Sign Up",
  "Remember my username": "Remember my username",
  Login: "Login",
  "Don't have an account yet?": "Don't have an account yet?",
  "Sign out": "Sign out",
  "Volt Merchant": "Volt Merchant",
  Dashboard: "Dashboard",
  Transactions: "Transactions",
  Applications: "Applications",
  Configuration: "Configuration",
  "Client applications": "Client applications",
  "Bank accounts": "Bank accounts",
  Users: "Users",
  "User management": "User management",
  Details: "Details",
  Copy: "Copy",
  "Copied to clipboard": "Copied to clipboard",
  OK: "OK",
  Delete: "Delete",
  Cancel: "Cancel",
  Filter: "Filter",
  "Something went wrong": "Something went wrong",
  "No results found": "No results found",
  Retry: "Retry",
  "Not saved": "Not saved",
};

export default common;
